
<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="dialog = true" v-bind="attrs" v-on="on" icon small :class="[['ml-1 mr-2'], [dark ? 'white primary--text' : 'primary white--text']]">
          <v-icon small>mdi-invoice-text-multiple</v-icon>
        </v-btn>
      </template>
      <span>Exibir faturas pagas</span>
    </v-tooltip>
    <v-dialog max-width="700px" v-model="dialog" persistent>
      <dialog-loading v-if="all_loadings"></dialog-loading>
      <v-card v-if="!all_loadings">
        <v-card-title>
          Faturas pagas
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text style="overflow-y: auto; max-height:75vh">
          <v-data-table :items="vrts" :headers="headers" :loading="all_loadings">
            <template v-slot:no-data>
              <b>
                Esse pagamento é antigo, e não possui histórico
                <v-icon left small class="grey--text">mdi-alert</v-icon>
              </b>
            </template>
            <template v-slot:item.order_id="{item}">
              {{ item.attributes.order_id || item.attributes.external_order_id }}
            </template>
            <template v-slot:item.attributes.paying_ammount="{item}">
              {{ Number(item.attributes.paying_ammount).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" small @click="dialog = false">Voltar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DialogOrdersPayedBySource',
  props: {
    payment_id: {
      type: [Number, String]
    },
    dark: {
      type: [Boolean],
      default: false,
    },
  },
  data() {
    return {
      vrts: [],
      dialog: false,
      all_loadings: false,
      headers: [
        { text: 'Pedido', value: 'order_id' },
        { text: 'Comentário', value: 'attributes.comment' },
        { text: 'Valor pago', value: 'attributes.paying_ammount' },
        { text: 'Cliente', value: 'attributes.client' },
      ],
    }
  },
  computed: {
    
  },
  methods: {
    openDialog(){
      this.dialog = true
    },
    getVrts(){
      if(this.payment_id){
        this.all_loadings = true
        let params = {
          payment_id: this.payment_id
        }
        Api.VrtTransaction.defaultIndex(params).then(res => res.data).then(res =>{
          this.vrts = [...res.data]
        }).finally(()=>{
          this.all_loadings = false
        })
      }
    }
  },
  watch:{
    dialog(nv){
      if(nv){
        this.getVrts()
      }
    }
  }
}
</script>